.field {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.label {
  font: var(--t-label-m);
  color: var(--c-text-tertiary);
}

.control {
  background: var(--c-surface-sunken);
  border: 1px solid var(--c-border);
  border-radius: var(--r-sm);
  padding: var(--sp-3) var(--sp-4);
  min-height: var(--tap-min);
  color: var(--c-text-primary);
  transition: border-color var(--dur-fast) var(--ease-standard);
}

.control::placeholder { color: var(--c-text-tertiary); }

.control:hover { border-color: var(--c-border-strong); }
.control:focus { border-color: var(--c-accent); }

textarea.control {
  min-height: 96px;
  resize: vertical;
  line-height: 1.6;
}

/* Ошибка — рамка И текст. Никогда только рамка. */
.invalid { border-color: var(--c-danger); }

.hint {
  font: var(--t-caption);
  color: var(--c-text-tertiary);
}

.error {
  font: var(--t-caption);
  color: var(--c-danger);
}
